import axios from "axios";

const apiUrl = "https://api.mci-server.modus.org";

export const getDataAPI = async (url) => {
  return axios.get(`${apiUrl + url}`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

// post
export const postDataAPI = async (url, post) => {
  return axios.post(`${apiUrl + url}`, post, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};
